/** @format */

import React, { useState, useEffect } from "react";
import { Button, notification, Modal, DatePicker, Spin } from "antd";
import imglogo from "../../../../assets/common/logo_rb.png";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useNavigate, useLocation } from "react-router-dom";
import { path, sessionVar } from "../../../../utils/common/constant";
import { Icon } from "@iconify/react/dist/iconify.js";
import { uploadFile } from "../../../../services/file";
import { Box } from "@mui/material";
import { getSessionVar } from "../../../../utils/common/hashData";
import { isValidInputProject } from "../../../../utils/common/validator";
import { Fancybox } from "../../../../components";
import EiditorProject from "../EiditorProject";
import { apiUpdateprojectByID } from "../../../../services/projects";
import {
  convertStringToArray,
  formatNumber,
} from "../../../../utils/common/hashData";
import { Detail } from "../../../../components";
import YouTube from "react-youtube";
import parse from "html-react-parser";

const EditProject = () => {
  const location = useLocation();
  const projectsData = location.state;
  dayjs.extend(customParseFormat);
  const dateFormat = "YYYY-MM-DD";
  const opts = {
    height: "360",
    width: "100%",
    playerVars: {
      autoplay: 0, // Don't autoplay on load
    },
  };
  const user = getSessionVar(sessionVar.user);
  const navigate = useNavigate();
  const [datadetail, setDatadetail] = useState({});
  useEffect(() => {
    if (!user) {
      navigate("../" + path.common.ADMIN);
    }
  }, []);

  const [formpayload, setformpayload] = useState({
    id: projectsData?.id,
    name: projectsData?.name,
    location: projectsData?.location,
    type: projectsData?.type,
    content: projectsData?.content,
    thumbnail: projectsData?.thumbnail,
    pictureUrl: projectsData?.pictureUrl,
    pictureGallery: convertStringToArray(projectsData?.pictureGallery),
    architecture: projectsData?.architecture,
    scale: projectsData?.scale,
    investor: projectsData?.investor,
    price: projectsData?.price,
    website: projectsData?.website,
    completionDate: projectsData?.completionDate,
    status: projectsData?.status,
  });
  const [file, setfile] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  // Lưu trạng thái lỗi cho từng input
  const [formErrors, setFormErrors] = useState({
    name: "",
    location: "",
    investor: "",
    type: "",
    price: "",
    thumbnail: "",
    pictureGallery: "",
    content: "",
  });
  const handleValidation = (field, value) => {
    setFormErrors((prev) => ({
      ...prev,
      [field]: value.trim() === "" || value.length === 0,
      // Đặt lỗi nếu input trống
    }));
  };
  const validateForm = () => {
    let errors = {};
    let isValid = true;

    if (!formpayload.name.trim()) {
      errors.name = "Project name cannot be empty.!";
      isValid = false;
    }

    if (!formpayload.location.trim()) {
      errors.location = "Location cannot be empty.!";
      isValid = false;
    }

    if (!formpayload.investor.trim()) {
      errors.investor = "Investor cannot be empty.!";
      isValid = false;
    }

    if (!formpayload.type.trim()) {
      errors.type = "Project type cannot be empty.!";
      isValid = false;
    }

    // Kiểm tra price rỗng
    if (!formpayload.price) {
      errors.price = "Total investments cannot be empty!";
      isValid = false;
    }
    // Kiểm tra price phải là một số
    else if (isNaN(formpayload.price) || formpayload.price <= 0) {
      errors.price = "Total investments must be number";
      isValid = false;
    }

    if (!formpayload.thumbnail.trim()) {
      errors.thumbnail = "Thumbnail cannot be empty.!";
      isValid = false;
    }
    if (formpayload.pictureGallery.length === 0) {
      errors.pictureGallery = "Picture Gallery cannot be empty.!";
      isValid = false;
    }
    if (!formpayload.content.trim()) {
      errors.content = "Content cannot be empty.!";
      isValid = false;
    }

    setFormErrors(errors);
    return isValid;
  };
  const handleSetContent = (e) => {
    setformpayload({ ...formpayload, content: e });
  };
  // Chọn 1 file từ bộ nhớ
  const handleFilePicTitleChange = (event) => {
    const item = event.target.files?.[0]; // Lấy file đầu tiên trong danh sách
    const allowedExtensions = ["webp", "png", "jpg", "jpeg"]; // Định dạng hợp lệ
    const maxFileSize = 10 * 1024 * 1024; // Giới hạn kích thước file: 10MB

    if (item) {
      const fileExtension = item.name.split(".").pop().toLowerCase(); // Lấy đuôi file

      if (!allowedExtensions.includes(fileExtension)) {
        // Kiểm tra đuôi file
        notification.error({
          message: `File "${item.name}" is not a valid image format.`,
          duration: 2,
          placement: "topRight",
        });
      } else if (item.size > maxFileSize) {
        // Kiểm tra kích thước file
        notification.error({
          message: `File "${item.name}" exceeds the 10MB size limit.`,
          duration: 2,
          placement: "topRight",
        });
      } else {
        // Nếu file hợp lệ, cập nhật state
        setfile(item);
      }
    }
  };

  // Chọn nhiều file từ bộ nhớ
  const handleFilePictureGallery = (event) => {
    const files = event.target.files;
    const allowedExtensions = ["webp", "png", "jpg", "jpeg"];
    const maxFileSize = 10 * 1024 * 1024;
    const validFiles = [];

    if (files) {
      // Lặp qua từng file để kiểm tra
      Array.from(files).forEach((file) => {
        const fileExtension = file.name.split(".").pop().toLowerCase();
        if (!allowedExtensions.includes(fileExtension)) {
          // Nếu đuôi file không hợp lệ
          notification.error({
            message: `File "${file.name}" is not a valid image format.`,
            duration: 2,
            placement: "topRight",
          });
        } else if (file.size > maxFileSize) {
          // Nếu kích thước file vượt quá 10MB
          notification.error({
            message: `File "${file.name}" exceeds the 10MB size limit.`,
            duration: 2,
            placement: "topRight",
          });
        } else {
          validFiles.push(file);
        }
      });

      // Cập nhật state nếu có file hợp lệ
      // Cập nhật state chỉ với file hợp lệ mới
      if (validFiles.length > 0) {
        setformpayload((prevPayload) => ({
          ...prevPayload,
          pictureGallery: validFiles, // Chỉ cập nhật với validFiles mới
        }));

        notification.success({
          message: `${validFiles.length} file(s) added successfully!`,
          duration: 2,
          placement: "topRight",
        });
      }
    }
  };

  const handleRemoveFile = (index) => {
    // Chuyển pictureGallery thành mảng và thực hiện xóa
    setformpayload((prevPayload) => {
      const updatedGallery = [...prevPayload.pictureGallery]; // Tạo bản sao của mảng pictureGallery
      if (index >= 0 && index < updatedGallery.length) {
        updatedGallery.splice(index, 1); // Xóa 1 phần tử tại vị trí index
      }

      return {
        ...prevPayload,
        pictureGallery: updatedGallery, // Cập nhật lại pictureGallery
      };
    });
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const handleUpload = async () => {
    if (file) {
      try {
        const formData = new FormData();
        formData.append("image", file); // Thêm file vào FormData
        const response = await uploadFile(formData);
        notification.success({
          message: "Upload image successfully  !!!",
          duration: 2,
          placement: "topRight",
        });
        setformpayload({ ...formpayload, thumbnail: response.path });
      } catch (error) {
        console.error("Upload Fail:", error);
      }
    } else {
      alert("Please select a file before uploading");
    }
  };

  // const handleUploadMultiple = async () => {
  //   if (formpayload?.pictureGallery.length > 0) {
  //     try {
  //       const uploadedPaths = []; // Mảng để lưu đường dẫn file đã upload

  //       for (const file of formpayload?.pictureGallery) {
  //         setLoading(true);
  //         const formData = new FormData();
  //         formData.append("image", file); // Thêm từng file vào FormData
  //         const response = await uploadFile(formData); // Gọi API upload từng file
  //         uploadedPaths.push(response.path); // Lưu đường dẫn ảnh đã upload
  //       }

  //       // Cập nhật trực tiếp formpayload.pictureGallery
  //       setformpayload((prevPayload) => ({
  //         ...prevPayload,
  //         pictureGallery: [
  //           ...(prevPayload.pictureGallery || []), // Giữ các ảnh cũ trong payload
  //           ...uploadedPaths, // Thêm các ảnh đã upload
  //         ],
  //       }));

  //       // Thông báo thành công
  //       notification.success({
  //         message: "Uploaded all images successfully!",
  //         duration: 2,
  //         placement: "topRight",
  //       });
  //     } catch (error) {
  //       console.error("Upload failed:", error);
  //       notification.error({
  //         message: "Failed to upload images",
  //         duration: 2,
  //         placement: "topRight",
  //       });
  //     } finally {
  //       setLoading(false);
  //     }
  //   } else {
  //     alert("Please select files before uploading");
  //   }
  // };

  const handleUploadMultiple = async () => {
    if (formpayload?.pictureGallery?.length > 0) {
      try {
        const uploadedPaths = []; // Mảng để lưu đường dẫn file đã upload

        for (const file of formpayload.pictureGallery) {
          console.log(typeof file);
          setLoading(true);
          const formData = new FormData();

          // Kiểm tra nếu file là kiểu hợp lệ (ví dụ: File object)
          if (file && file instanceof File) {
            formData.append("image", file); // Thêm từng file vào FormData
            const response = await uploadFile(formData); // Gọi API upload từng file

            if (response?.path) {
              uploadedPaths.push(response.path); // Lưu đường dẫn ảnh đã upload nếu hợp lệ
            }
          }
        }

        const validPaths = uploadedPaths.filter(
          (path) => typeof path === "string" && path.trim() !== ""
        );

        setformpayload((prevPayload) => ({
          ...prevPayload,
          pictureGallery: validPaths.filter(
            (item) => typeof item === "string" && item.trim() !== ""
          ), // Chỉ thêm các giá trị kiểu string mới
        }));

        // Thông báo thành công
        notification.success({
          message: "Uploaded all images successfully!",
          duration: 2,
          placement: "topRight",
        });
      } catch (error) {
        console.error("Upload failed:", error);
        notification.error({
          message: "Failed to upload images",
          duration: 2,
          placement: "topRight",
        });
      } finally {
        setLoading(false);
      }
    } else {
      alert("Please select files before uploading");
    }
  };

  const handleDateChange = (date, dateString) => {
    if (date) {
      const selectedDate = new Date(dateString); // Ngày được chọn
      const currentdate = new Date();
      // So sánh ngày
      const newStatus =
        selectedDate < currentdate ? "Completed" : "In Progress";

      // Cập nhật trạng thái và completionDate
      setformpayload({
        ...formpayload,
        completionDate: dateString, // dateString đã được định dạng sẵn
        status: newStatus,
      });
    } else {
      // Xử lý khi giá trị không hợp lệ
      setformpayload({
        ...formpayload,
        completionDate: null,
        status: "", // Đặt lại status nếu không có completionDate hợp lệ
      });
    }
  };

  const handleEditProject = async () => {
    if (!validateForm()) {
      notification.error({
        message: "Please fill in all information.",
        duration: 2,
        placement: "topRight",
      });
      return; // Nếu có lỗi, không gọi API
    }

    await apiUpdateprojectByID(formpayload)
      .then((res) => {
        if (res.data.status == 201 || res.data.status == 200) {
          notification.success({
            message: "Update successfuly !!!",
            duration: 2,
            placement: "topRight",
          });
          navigate("../" + path.private.MANAGEPROJECTS);
        }
      })
      .catch((err) => {
        if (err.status === 401) {
          notification.info({
            message: "Your login session has expired  !!!",
            duration: 3,
            placement: "topRight",
          });
          navigate("../" + path.common.LOGIN);
        }
      });
  };
  return (
    <div className="">
      <div className="w-[90%] mx-auto h-auto bg-white shadow-xl rounded-lg p-1">
        <div className="flex p-2">
          <p className="text-2xl">Edit Prioject</p>
        </div>
        <div className="px-10 py-4 pv:max-ph:px-0 mx-auto w-[100%]">
          {/* Project Name */}
          <div className="w-full h-auto flex flex-col justify-start items-start gap-y-2 pb-6">
            <div className="flex items-center gap-2">
              <p className="text-lg">
                Project Name
                <span className="text-red-500 text-[10px]">( * required)</span>
              </p>
              {formErrors.name && (
                <p className="text-red-500 text-[10px]">{formErrors.name}</p>
              )}
            </div>

            <input
              className={`w-full h-auto border-[1px] rounded-lg p-2 shadow-sm transition duration-300 focus:outline-none 
    ${
      formErrors.name
        ? "border-red-500 focus:ring-red-500 focus:border-red-500"
        : "border-gray-300 focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
    } 
    bg-white text-gray-800 placeholder-gray-400 hover:shadow-md`}
              placeholder="Project Name"
              value={formpayload.name}
              onBlur={(e) => handleValidation("name", e.target.value)}
              onChange={(e) =>
                setformpayload({ ...formpayload, name: e.target.value })
              }
            />
          </div>

          <div className="grid grid-cols-3 gap-4">
            {/*Investor */}
            <div className="w-full h-auto flex flex-col justify-start items-start gap-y-2 pb-6">
              <div className="flex items-center gap-2">
                <p className="text-lg">
                  Investor
                  <span className="text-red-500 text-[10px]">
                    ( * required)
                  </span>
                </p>
                {formErrors.investor && (
                  <p className="text-red-500 text-[10px]">
                    {formErrors.investor}
                  </p>
                )}
              </div>
              <input
                className={`w-full h-auto border-[1px] rounded-lg p-2 shadow-sm transition duration-300 focus:outline-none 
    ${
      formErrors.investor
        ? "border-red-500 focus:ring-red-500 focus:border-red-500"
        : "border-gray-300 focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
    } 
    bg-white text-gray-800 placeholder-gray-400 hover:shadow-md`}
                placeholder="Investor"
                value={formpayload.investor}
                onBlur={(e) => handleValidation("investor", e.target.value)}
                onChange={(e) =>
                  setformpayload({ ...formpayload, investor: e.target.value })
                }
              />
            </div>
            {/* Location */}
            <div className="w-full h-auto flex flex-col justify-start items-start gap-y-2 pb-6">
              <div className="flex items-center gap-2">
                <p className="text-lg">
                  Location
                  <span className="text-red-500 text-[10px]">
                    ( * required)
                  </span>
                </p>
                {formErrors.location && (
                  <p className="text-red-500 text-[10px]">
                    {formErrors.location}
                  </p>
                )}
              </div>
              <input
                className={`w-full h-auto border-[1px] rounded-lg p-2 shadow-sm transition duration-300 focus:outline-none 
    ${
      formErrors.location
        ? "border-red-500 focus:ring-red-500 focus:border-red-500"
        : "border-gray-300 focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
    } 
    bg-white text-gray-800 placeholder-gray-400 hover:shadow-md`}
                placeholder="Location"
                value={formpayload.location}
                onBlur={(e) => handleValidation("location", e.target.value)}
                onChange={(e) =>
                  setformpayload({ ...formpayload, location: e.target.value })
                }
              />
            </div>
            {/* Project Type */}
            <div className="w-full h-auto flex flex-col justify-start items-start gap-y-2 pb-6">
              <div className="flex items-center gap-2">
                <p className="text-lg">
                  Project Type
                  <span className="text-red-500 text-[10px]">
                    ( * required)
                  </span>
                </p>
                {formErrors.type && (
                  <p className="text-red-500 text-[10px]">{formErrors.type}</p>
                )}
              </div>
              <input
                className={`w-full h-auto border-[1px] rounded-lg p-2 shadow-sm transition duration-300 focus:outline-none 
    ${
      formErrors.type
        ? "border-red-500 focus:ring-red-500 focus:border-red-500"
        : "border-gray-300 focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
    } 
    bg-white text-gray-800 placeholder-gray-400 hover:shadow-md`}
                placeholder="Project Type"
                value={formpayload.type}
                onBlur={(e) => handleValidation("type", e.target.value)}
                onChange={(e) =>
                  setformpayload({ ...formpayload, type: e.target.value })
                }
              />
            </div>
          </div>

          <div className="grid grid-cols-3 gap-4">
            {/* Architecture*/}
            <div className="w-full h-auto flex flex-col justify-start items-start gap-y-2 pb-6">
              <p className="text-lg">Architecture</p>

              <input
                className="w-full h-auto border-[1px] rounded-lg p-2 shadow-sm transition duration-300 focus:outline-none border-gray-300 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 bg-white text-gray-800 placeholder-gray-400 hover:shadow-md"
                placeholder="Architecture"
                value={formpayload.architecture}
                onChange={(e) =>
                  setformpayload({
                    ...formpayload,
                    architecture: e.target.value,
                  })
                }
              />
            </div>

            {/* youtube*/}
            <div className="w-full h-auto flex flex-col justify-start items-start gap-y-2 pb-6">
              <p className="text-lg">youtube</p>

              <input
                className="w-full h-auto border-[1px] rounded-lg p-2 shadow-sm transition duration-300 focus:outline-none border-gray-300 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 bg-white text-gray-800 placeholder-gray-400 hover:shadow-md"
                placeholder="Youtube URL"
                value={formpayload.pictureUrl}
                onChange={(e) =>
                  setformpayload({ ...formpayload, pictureUrl: e.target.value })
                }
              />
            </div>
            {/* Scale*/}
            <div className="w-full h-auto flex flex-col justify-start items-start gap-y-2 pb-6">
              <p className="text-lg">Scale</p>

              <input
                className="w-full h-auto border-[1px] rounded-lg p-2 shadow-sm transition duration-300 focus:outline-none border-gray-300 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 bg-white text-gray-800 placeholder-gray-400 hover:shadow-md"
                placeholder="Scale Project"
                value={formpayload.scale}
                onChange={(e) =>
                  setformpayload({ ...formpayload, scale: e.target.value })
                }
              />
            </div>
          </div>

          <div className="grid grid-cols-3 gap-4">
            {/* Total investment*/}
            <div className="w-full h-auto flex flex-col justify-start items-start gap-y-2 pb-6">
              <div className="flex items-center gap-2">
                <p className="text-lg">
                  Total Investments (USD)
                  <span className="text-red-500 text-[10px]">
                    ( * required)
                  </span>
                </p>
                {formErrors.price && (
                  <p className="text-red-500 text-[10px]">{formErrors.price}</p>
                )}
              </div>
              <input
                className={`w-full h-auto border-[1px] rounded-lg p-2 shadow-sm transition duration-300 focus:outline-none 
    ${
      formErrors.price
        ? "border-red-500 focus:ring-red-500 focus:border-red-500"
        : "border-gray-300 focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
    } 
    bg-white text-gray-800 placeholder-gray-400 hover:shadow-md`}
                placeholder="Total investments"
                value={formpayload.price}
                onBlur={(e) => handleValidation("price", e.target.value)}
                onChange={(e) =>
                  setformpayload({ ...formpayload, price: e.target.value })
                }
              />
            </div>

            {/* Estimated Completion Time*/}
            <div className="w-full h-auto flex flex-col justify-start items-start gap-y-2 pb-6">
              <p className="text-lg">Estimated Completion Time</p>

              <DatePicker
                allowClear={false}
                value={
                  formpayload.completionDate
                    ? dayjs(formpayload.completionDate, dateFormat)
                    : null
                }
                placeholder="YYYY-MM-DD"
                onChange={handleDateChange} // Handle date change
                format={"YYYY-MM-DD"}
                placement="bottomLeft"
                className="w-full h-auto border-[1px] rounded-lg p-2 shadow-sm transition duration-300 focus:outline-none border-gray-300 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 bg-white text-gray-800 placeholder-gray-400 hover:shadow-md "
              />
            </div>
            {/* Website link*/}
            <div className="w-full h-auto flex flex-col justify-start items-start gap-y-2 pb-6">
              <p className="text-lg">Website</p>

              <input
                className="w-full h-auto border-[1px] rounded-lg p-2 shadow-sm transition duration-300 focus:outline-none border-gray-300 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 bg-white text-gray-800 placeholder-gray-400 hover:shadow-md"
                placeholder="Webiste link"
                value={formpayload.website}
                onChange={(e) =>
                  setformpayload({ ...formpayload, website: e.target.value })
                }
              />
            </div>
          </div>

          <div className="grid grid-cols-3 gap-4">
            <div className="">
              <div className="flex flex-col justify-start items-start gap-y-2 pb-4">
                <div className="">
                  <p className="text-lg flex pv:max-ph:flex-col">
                    Thumbnail
                    <span className="text-[10px]">
                      (jpg jpeg png webp (2MB))
                    </span>
                    {formErrors.thumbnail && (
                      <p className="text-red-500 text-[10px] pl-2">
                        {formErrors.thumbnail}
                      </p>
                    )}
                  </p>
                  <span className="text-red-500 text-[10px]">
                    ( * Click upload image before saving )
                  </span>
                </div>

                <input
                  type="file"
                  accept="image/jpeg, image/png img/webp"
                  onBlur={(e) => handleValidation("thumbnail", e.target.value)}
                  onChange={(e) => {
                    handleFilePicTitleChange(e);
                  }}
                />

                <Button
                  type="primary"
                  className=" w-[100px]"
                  onClick={(e) => {
                    handleUpload();
                  }}
                >
                  <Icon
                    icon={"flowbite:upload-outline"}
                    className="w-6 h-6"
                  ></Icon>
                </Button>
              </div>
              <img
                className={`w-full h-[200px] object-cover `}
                alt="Image thumbnail"
                src={formpayload.thumbnail}
              ></img>
            </div>
            {loading && (
              <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                <Spin size="large" tip="Uploading..." className="text-white" />
              </div>
            )}
            <div
              className={`${loading ? "opacity-50 pointer-events-none" : ""} col-span-2`}
            >
              <div className="flex flex-col gap-2 ">
                <div className="">
                  <p className="text-lg flex pv:max-ph:flex-col">
                    Picture Gallery
                    <span className="text-[10px]">
                      (jpg jpeg png webp (2MB))
                    </span>
                    {formErrors.pictureGallery && (
                      <p className="text-red-500 text-[10px] pl-2">
                        {formErrors.pictureGallery}
                      </p>
                    )}
                  </p>
                  <span className="text-red-500 text-[10px]">
                    ( * Click upload image before saving )
                  </span>
                </div>
                <input
                  type="file"
                  multiple
                  accept="image/*"
                  onBlur={(e) =>
                    handleValidation("pictureGallery", e.target.value)
                  }
                  onChange={handleFilePictureGallery}
                />
                <Button
                  type="primary"
                  className=" w-[100px]"
                  onClick={(e) => {
                    handleUploadMultiple();
                  }}
                >
                  <Icon
                    icon={"flowbite:upload-outline"}
                    className="w-6 h-6"
                  ></Icon>
                </Button>
              </div>
              <div className="grid grid-cols-4 py-4 gap-4">
                {formpayload?.pictureGallery?.map((file, index) => (
                  <div key={index} className="relative">
                    <img
                      src={file}
                      alt={`Preview ${file.name}`}
                      className="w-[300px] h-[200px] object-cover"
                    />
                    <button
                      className="absolute top-0 left-0 p-2  bg-white"
                      onClick={() => handleRemoveFile(index)}
                    >
                      <Icon
                        className="text-red-500"
                        icon={"material-symbols:delete-outline"}
                      ></Icon>
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="w-full h-auto flex flex-col justify-start items-start gap-y-2 pb-20">
            <p className="text-lg">
              Content
              <span className="text-[10px] text-red-500">
                ( * Content to display on the details page)
              </span>
            </p>
            <div className="w-full">
              <Box sx={{ margin: "0 auto" }}>
                <EiditorProject
                  setDescription={handleSetContent}
                  content={formpayload?.content}
                />
              </Box>

              <button
                className="px-6 py-2 rounded-lg bg-primary text-white my-4"
                onClick={() => {
                  setIsModalOpen(!isModalOpen);
                }}
              >
                {isModalOpen ? "Hidden" : "Preview"}
              </button>
            </div>
          </div>

          <div className="flex justify-center items-center gap-x-4">
            <Button
              className="w-auto h-auto py-2 px-4 "
              onClick={() => {
                navigate(-1);
              }}
            >
              <p className="">Back</p>
            </Button>

            <Button
              className="w-auto h-auto py-2 px-4 "
              type="primary"
              onClick={() => {
                handleEditProject();
              }}
            >
              <p className="">Save</p>
            </Button>
          </div>
        </div>
      </div>
      <Modal
        title=<div className="flex justify-between ">
          <p className="text-center text-primary"> {datadetail?.name}</p>
          <button
            className=""
            onClick={() => {
              handleCancel();
            }}
          >
            <Icon
              icon={"material-symbols:close"}
              className="h-6 w-6 text-primary"
            ></Icon>
          </button>
        </div>
        open={isModalOpen}
        onOk={handleOk}
        width={"100%"}
        centered
        onCancel={handleCancel}
        closable={false}
        footer={null}
      >
        <div className="w-full overflow-y-auto h-[90vh]">
          <div className="w-full">
            {/* Banner */}
            <div className="relative w-full h-[50vh] md:h-[calc(100vh-132px)] overflow-hidden">
              {formpayload?.thumbnail ? (
                <img
                  src={formpayload.thumbnail}
                  className="absolute w-full h-full object-cover object-bottom"
                  alt="Project Banner"
                />
              ) : (
                <div className="absolute w-full h-full bg-gray-200 flex items-center justify-center text-primary">
                  No banner image available
                </div>
              )}
            </div>
            <div className="max-w-[1140px] mx-auto pt-10 w-[80%]  qhd:max-w-[100%] qhd:w-[100%] ">
              {/* Project info basic */}
              <div className="pb-2">
                <div className="">
                  <p className=" pb-[1.25rem] pv:max-lg:pb-2 text-[2.5rem] qhd:text-[2.5rem]  font-medium text-primary leading-tight">
                    {formpayload?.name}
                  </p>
                </div>
                <div className="">
                  <p className="text-[1.125rem]  qhd:text-[1.125rem]  whitespace-pre-line text-primary text-justify leading-relaxed">
                    {formpayload?.location}
                  </p>
                </div>
              </div>
              {/* Picture gallery */}
              <div className="grid grid-cols-3 gap-4 pv:max-lg:grid-cols-1">
                <div className="col-span-2 pv:max-lg:col-span-1">
                  <Fancybox
                    options={{
                      Carousel: {
                        infinite: false,
                      },
                    }}
                  >
                    {formpayload.pictureGallery?.map((item, index) => {
                      return (
                        <div
                          className={`overflow-hidden ${index === 0 ? "" : "hidden"}`}
                        >
                          <a className="" data-fancybox="gallery" href={item}>
                            <img
                              src={item}
                              alt="Main"
                              className="cursor-zoom-in w-full md:h-[400px] object-cover rounded-lg "
                            />
                          </a>
                        </div>
                      );
                    })}
                  </Fancybox>
                </div>
                <div className="col-span-1 pv:max-lg:col-span-1">
                  <Fancybox
                    options={{
                      Carousel: {
                        infinite: false,
                      },
                    }}
                  >
                    <div className=" grid  gap-4 pv:max-lg:grid-cols-2 ">
                      {formpayload.pictureGallery?.map((item, index) => {
                        return (
                          <div
                            key={index}
                            className={`rounded-lg ${index === 2 ? "shadow-custom-image " : ""} overflow-hidden ${index === 0 || index >= 3 ? "hidden" : ""}`}
                          >
                            {item ? (
                              <a
                                className="relative"
                                data-fancybox="gallery"
                                href={item}
                              >
                                <img
                                  src={item}
                                  alt={`Thumbnail ${index + 1}`}
                                  className={` cursor-zoom-in w-full h-[192px] rounded-lg  object-cover hover:scale-105 transition-transform duration-300`}
                                />
                                <p
                                  className={`${index === 2 && convertStringToArray(datadetail?.pictureGallery).length > 3 ? "absolute" : "hidden"}  bottom-4 right-4 px-4 py-2  pv:max-ph:py-0  pv:max-ph:right-0  pv:max-ph:bottom-0 bg-white text-primary_light bg-opacity-60 rounded-lg `}
                                >
                                  View more images
                                </p>
                              </a>
                            ) : (
                              <div className="w-full h-[100px] bg-gray-200 flex items-center justify-center">
                                No image
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </Fancybox>
                </div>
              </div>

              {/* Other information */}
              <div className="grid grid-cols-3 gap-4  pv:max-lg:grid-cols-1">
                <div className="col-span-2 pv:max-lg:col-span-1 ">
                  <div className="  shadow-custom-activity rounded-lg  my-10 pv:max-lg:my-2  ">
                    <div className="flex h-[100px] items-center pv:max-lg:h-full pv:max-lg:py-2  justify-around  pv:max-lg:flex-col pv:max-lg:gap-2 pv:max-lg:w-[95%] pv:max-lg:mx-auto text-[1rem]">
                      <div className=" pv:max-lg:w-full">
                        <p className="   whitespace-pre-line text-primary text-justify leading-relaxed ">
                          Architecture
                        </p>
                        <div className="flex items-center gap-1">
                          <p className=" whitespace-pre-line text-primary_light text-justify leading-relaxed font-bold">
                            {formpayload?.architecture}
                          </p>
                        </div>
                      </div>
                      <div className="pv:max-lg:w-full">
                        <p className="  whitespace-pre-line text-primary text-justify leading-relaxed ">
                          Scale
                        </p>
                        <div className="flex items-center gap-1">
                          <p className="  text-primary_light font-bold">
                            {formpayload?.scale}
                          </p>
                        </div>
                      </div>
                      <div className=" pv:max-lg:w-full">
                        <p className="   whitespace-pre-line text-primary  leading-relaxed ">
                          Project Type
                        </p>
                        <div className="flex items-center gap-1">
                          <p className="  text-primary_light font-bold">
                            {formpayload?.type}
                          </p>
                        </div>
                      </div>
                      <div className=" pv:max-lg:w-full">
                        <p className="   whitespace-pre-line text-primary text-justify leading-relaxed ">
                          Status
                        </p>
                        <div className="flex items-center gap-1 ">
                          <p className=" text-primary_light font-bold">
                            {formpayload?.status}
                          </p>
                        </div>
                      </div>
                      <div className=" pv:max-lg:w-full">
                        <p className="    whitespace-pre-line text-primary text-justify leading-relaxed ">
                          Date
                        </p>
                        <div className="flex items-center gap-1 ">
                          <p className=" text-primary_light font-bold">
                            {formpayload?.completionDate}
                          </p>
                        </div>
                      </div>
                      {/* project Type Mobile */}
                      <div className=" pv:max-lg:w-full lg:hidden">
                        <p className=" whitespace-pre-line text-primary text-justify leading-relaxed ">
                          Total investments
                        </p>
                        <div className="flex items-center gap-1 ">
                          <p className=" text-primary_light font-bold">
                            {formatNumber(formpayload?.price)} USD
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-span-1 pv:max-lg:hidden  ">
                  <div className="shadow-custom-activity  rounded-lg h-[100px] my-10 pv:max-lg:my-2 flex flex-col  p-2  justify-center ">
                    <p className="text-[1rem]  qhd:text-[1.125rem]  whitespace-pre-line text-primary leading-relaxed ">
                      Total investments
                    </p>
                    <p className="text-primary_light text-[2rem]">
                      {formatNumber(formpayload?.price)} USD
                    </p>
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4 pv:max-lg:grid-cols-1">
                <div className="col-span-2 pv:max-lg:grid-cols-1 ">
                  <div className="">
                    <div className="ProseMirror text-primary">
                      {parse(formpayload?.content)}
                    </div>
                  </div>
                  <div className="mt-6 p-[10px]">
                    <div className="w-full ">
                      <YouTube
                        videoId={formpayload?.pictureUrl}
                        opts={opts}
                        className="w-full h-full"
                      />
                    </div>
                  </div>
                </div>
                <div className="">
                  <div className=" pv:max-lg:w-full ">
                    <div className="col-span-1 shadow-custom-activity h-[180px]    rounded-lg py-[20px] flex gap-2 items-center  ">
                      <div className="p-4 m-2 rounded-lg bg-primary/5">
                        <img
                          className="h-[120px] pv:max-md:h-[80px] "
                          src={imglogo}
                        ></img>
                      </div>
                      <div className="">
                        <div className="">
                          <p className="text-[1rem]  qhd:text-[1.125rem]  whitespace-pre-line text-primary text-justify leading-relaxed ">
                            Investor
                          </p>
                          <p className="text-[1rem] text-primary_light">
                            {formpayload?.investor}
                          </p>
                        </div>
                        <div className="flex gap-2 text-base text-primary_light items-center">
                          <Icon icon={"ic:outline-phone"}></Icon>
                          <p className="">+ 61 411 896 553</p>
                        </div>
                        <div className="flex gap-2 text-base text-primary_light items-center">
                          <Icon icon={"ic:outline-email"}></Icon>
                          <p className="">info@idg-global.com</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default EditProject;
